import { render, staticRenderFns } from "./SendClientMessage.vue?vue&type=template&id=699b8e69&"
import script from "./SendClientMessage.vue?vue&type=script&lang=js&"
export * from "./SendClientMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports